import $ from 'jquery';
import * as bootstrap from 'bootstrap';

window.jQuery = window.$ = $;
window.bootstrap = bootstrap;
